import { useQuestionSections, useRdPageLockStatus, usePriorYearRevenues } from '@neo.tax/rd/hooks';
import { RedirectState, useCurrentCompany, useCurrentCompanyId } from '@neo.tax/shared';

export const useCreditCalculationRedirect = (): RedirectState => {
  const { loading: companyLoading } = useCurrentCompany();
  const { loading: questionSectionsLoading } = useQuestionSections();
  const { loading: loadingPageLockStatus } = useRdPageLockStatus();
  const companyId = useCurrentCompanyId();
  const { loading: priorYearRevenuesLoading } = usePriorYearRevenues({ companyId });
  return {
    isLoading: companyLoading || questionSectionsLoading || loadingPageLockStatus || priorYearRevenuesLoading,
  };
};
